import asyncComponent from '../common/utils/async-component';

const Dashboard = asyncComponent(async () => import('./components/dashboard'));

export default {
  components: { main: Dashboard }
};
